import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BounceLoader } from 'react-spinners';
import Button from '../../common/components/Button';
import { getCopy } from '../../common/lib/copyDefaults';
import { maskEmail } from '../../common/lib/maskEmail';
import { fetchUser } from '../../services/auth';
import {
  pollEmailVerification,
  stopPollEmailVerification,
  resendEmailVerification,
} from '../../redux/actions';

import '../../../style/index.css';
import './checkEmail.css';

const mapStateToProps = (state) => ({
  isResendingEmail: state.registerReducer.isResendingEmail,
  resendEmailMessage: state.registerReducer.resendEmailMessage,
  resendEmailMessageIsError: state.registerReducer.resendEmailMessageIsError,
  resendCooldownRemaining: state.registerReducer.resendCooldownRemaining,
});

const mapDispatchToProps = {
  pollEmailVerification,
  stopPollEmailVerification,
  resendEmailVerification,
};

class CheckEmailView extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    pollEmailVerification: PropTypes.func.isRequired,
    stopPollEmailVerification: PropTypes.func.isRequired,
    resendEmailVerification: PropTypes.func.isRequired,
    isResendingEmail: PropTypes.bool.isRequired,
    resendEmailMessage: PropTypes.string.isRequired,
    resendEmailMessageIsError: PropTypes.bool.isRequired,
    resendCooldownRemaining: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleResendClick = this.handleResendClick.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.startPolling = this.startPolling.bind(this);
  }

  startPolling() {
    const {
      pollEmailVerification, stopPollEmailVerification, history,
    } = this.props;
    stopPollEmailVerification();
    pollEmailVerification(history.push);
  }

  componentDidMount() {
    this.startPolling();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    requestAnimationFrame(() => {
      const el = document.getElementById('check-email-heading');
      if (el) {
        el.focus();
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.props.stopPollEmailVerification();
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.startPolling();
    }
  }

  handleResendClick(e) {
    e.preventDefault();
    const {
      isResendingEmail,
      resendCooldownRemaining,
      resendEmailVerification,
      history,
    } = this.props;
    if (isResendingEmail || resendCooldownRemaining > 0) {
      return;
    }
    resendEmailVerification(history.push);
  }

  render() {
    const copy = getCopy('/check-email');
    const user = fetchUser();
    const emailFromToken = user.identity && user.identity.email;
    const email = maskEmail(emailFromToken || '');
    const {
      isResendingEmail,
      resendEmailMessage,
      resendEmailMessageIsError,
      resendCooldownRemaining,
    } = this.props;
    const resendDisabled = isResendingEmail || resendCooldownRemaining > 0;
    const cooldownMessage = resendCooldownRemaining > 0
      ? copy.resendCooldown.replace('{seconds}', String(resendCooldownRemaining))
      : '';

    return (
      <div className="check-email row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <div className="check-email__body">
            <h1 id="check-email-heading" tabIndex={-1} className="check-email__title">
              {copy.header}
            </h1>
            <p className="check-email__description">{copy.body}</p>
            <p className="check-email__email">
              <strong>{email}</strong>
            </p>
            <p className="check-email__helper">
              {copy.resendHelperPre}
              <strong>{copy.resendHelperBold}</strong>
              {copy.resendHelperPost}
            </p>
          </div>
          <div className="button-wrap">
            {isResendingEmail ? (
              <div className="loading-wrapper">
                <BounceLoader color="#084267" />
              </div>
            ) : (
              <Button
                label={copy.resendHelperBold}
                onClickFn={this.handleResendClick}
                className={resendDisabled ? 'nyl-button disabled' : 'nyl-button'}
                disabled={resendDisabled}
                id="check-email-resend-button"
              />
            )}
            {(resendEmailMessage || cooldownMessage) && (
              <div
                className="check-email__resend-status"
                role="status"
                aria-live="polite"
                aria-atomic="true"
              >
                {resendEmailMessage && (
                  <p className={resendEmailMessageIsError ? 'submit-error' : 'check-email__resend-success'}>
                    {resendEmailMessage}
                  </p>
                )}
                {cooldownMessage && (
                  <p className="check-email__resend-cooldown">{cooldownMessage}</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckEmailView));
